import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type TemperatureSensorTypeSortDirection = "ASC" | "DESC";

export interface TemperatureSensorTypeListParams {
  page?: number;
  size?: number;
  sort?: TemperatureSensorTypeSortDirection;
  sortBy?: string;
}

export interface TemperatureSensorTypeRecord {
  id: string | number;
  name?: string;
  code?: string;
  description?: string;
  active?: boolean | number | string;
  baseType?: boolean;
  usedForMapping?: boolean;
  createDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  [key: string]: unknown;
}

export interface TemperatureSensorTypePayload {
  active: boolean;
  description?: string;
  name: string;
  createDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
}

export interface TemperatureSensorTypeStatusPayload {
  id: string | number;
  active: boolean;
}

export interface TemperatureSensorTypePaginatedResponse {
  temperatureTypes?: TemperatureSensorTypeRecord[];
  temperatureSensorTypes?: TemperatureSensorTypeRecord[];
  data?: TemperatureSensorTypeRecord[];
  items?: TemperatureSensorTypeRecord[];
  content?: TemperatureSensorTypeRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

const replaceId = (url: string, id: string | number) =>
  url.replace("{id}", String(id));

export const getTemperatureSensorTypesList = (
  params: TemperatureSensorTypeListParams = {},
  language?: string,
) =>
  ApiService.get<{ response: TemperatureSensorTypePaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TEMPERATURE_SENSOR_TYPES.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    },
  );

export const getTemperatureSensorTypeById = (
  id: string | number,
  language?: string,
) =>
  ApiService.get<{ response: TemperatureSensorTypeRecord }>(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.TEMPERATURE_SENSOR_TYPES.GET,
      id,
    ),
    getLanguageHeaders(language),
  );

export const createTemperatureSensorType = (
  payload: TemperatureSensorTypePayload,
  language?: string,
) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TEMPERATURE_SENSOR_TYPES.ADD,
    payload,
    getLanguageHeaders(language),
  );

export const updateTemperatureSensorType = (
  id: string | number,
  payload: TemperatureSensorTypePayload & { id: string | number },
  language?: string,
) =>
  ApiService.patch(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.TEMPERATURE_SENSOR_TYPES.UPDATE,
      id,
    ),
    payload,
    getLanguageHeaders(language),
  );

export const updateTemperatureSensorTypeStatus = (
  id: string | number,
  payload: TemperatureSensorTypeStatusPayload,
  language?: string,
) =>
  ApiService.patch(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.TEMPERATURE_SENSOR_TYPES.UPDATE,
      id,
    ),
    payload,
    getLanguageHeaders(language),
  );

export const deleteTemperatureSensorType = (
  id: string | number,
  language?: string,
) =>
  ApiService.delete(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.TEMPERATURE_SENSOR_TYPES.DELETE,
      id,
    ),
    getLanguageHeaders(language),
  );
